<template lang="pug">
div
  card-financeiro(
    cardTitle="Emissão do DAE"
  )
    template(slot="body")
      validation-observer(ref='observer', tag='form', v-slot="{ invalid }")
        form(@submit.prevent="onSubmit")
          app-divider.margin-bottom-20(label="Dados do processo")
          el-row.margin-bottom-20(type="flex", :gutter="40")
            el-col(:lg="12")
              app-label(label="Número do processo:")
              el-input.input(v-model="dae.processoFisico.numero", :disabled="inputDisabled")
            el-col(:lg="12")
              app-label(label="Tipo de processo:")
              el-input.input(v-model="dae.processoFisico.tipoCadastro.nome", :disabled="inputDisabled")
          el-row.margin-bottom-20(type="flex", :gutter="40")
            el-col(:lg="12")
              app-label(label="Nome/Razão social do interessado:")
              el-input.input(v-model="dae.processoFisico.nomeRazaoSocialInteressado", :disabled="inputDisabled")
            el-col(:lg="12")
              app-label(label="CPF/CNPJ do interessado:")
              el-input.input(v-model="dae.processoFisico.cpfCnpjInteressado", :disabled="inputDisabled")
          el-row.margin-bottom-20(type="flex", :gutter="40")
            el-col(:lg="12")
              app-label(label="Telefone:")
              el-input.input(v-model="dae.processoFisico.telefone", :disabled="inputDisabled")
            el-col(:lg="12")
              app-label(label="E-mail:")
              el-input.input(v-model="dae.processoFisico.email", :disabled="inputDisabled")

          .container-input#custas
            validation-provider(rules="required", v-slot="{ errors }", name="Tipo custa")
              app-label(label="Tipo de custa")
              el-radio-group.checkbox-group.input(v-model="dae.tipoCusta" :class="{'erro' : errors.length}" @change="() => dae.custas = []")
                el-radio(label="PROCESSUAIS") Custas processuais
                el-radio(label="AGRARIAS") Custas agrárias
              span.help.erro {{ errors[0] }}

          .container-input(v-if="dae.tipoCusta")
            app-divider.container-input(:label="dae.tipoCusta === 'PROCESSUAIS' ? 'Custas processuais' : 'Custas agrárias'", :showBorder="true")
            .custas
              .input-custas(v-for="custa in tiposCustas.filter(item => item.grupo === dae.tipoCusta)")
                span.span-item {{ custa.descricao }}
                el-input-number.input-item(:value="getCustaValue(custa.id)" @change="handleChange($event, custa)", :min="0", size="small")

          app-divider.margin-bottom-20(label="Dados do DAE")
          div
            el-row.margin-bottom-20(type="flex", :gutter="40")
              el-col(:lg="12")
                validation-provider(rules="required", v-slot="{ errors }", name="receita", slim)
                  app-label(label="Receita:", :required="true")
                  el-select.select.input(
                      class="select",
                      v-model="dae.tipoReceita",
                      value-key="id",
                      name="receita"
                      placeholder="Selecione",
                      :class="{'erro' : errors.length}"
                      clearable
                    )
                    el-option(
                      v-for="item in receitas"
                      :key="item.id"
                      :label="item.descricao"
                      :value="item"
                    )
                  span.help.erro {{ errors[0] }}
              el-col(:lg="12")
                validation-provider(rules="required", v-slot="{ errors }", name="dataReferencia")
                  app-label(label="Referência:", :required="true")
                  el-date-picker.input.full-width(
                    disabled
                    v-model="dae.dataReferencia",
                    name="dataReferencia",
                    type='date',
                    placeholder='Selecione',
                    format="MM/yyyy",
                    :class="{'erro' : errors.length}"
                  )
                  span.help.erro {{ errors[0] }}
            el-row.margin-bottom-20(type="flex", :gutter="40")
              el-col(:lg="12")
                validation-provider(rules="required", v-slot="{ errors }", name="dataVencimento")
                  app-label(label="Data de vencimento:", :required="true")
                  el-date-picker.input.full-width(
                    v-model="dae.dataVencimento",
                    name="dataVencimento",
                    type='date',
                    placeholder='Selecione',
                    format="dd/MM/yyyy",
                    :picker-options="pickerOptions",
                    :class="{'erro' : errors.length}"
                  )
                  span.help.erro {{ errors[0] }}
              el-col(:lg="12")
                validation-provider(rules="required", v-slot="{ errors }", name="dataCalculo")
                  app-label(label="Data do cálculo:", :required="true")
                  el-date-picker.input.full-width(
                    disabled
                    v-model="dae.dataCalculo",
                    name="dataCalculo",
                    type='date',
                    placeholder='Selecione',
                    format="dd/MM/yyyy",
                    :picker-options="pickerOptions",
                    :class="{'erro' : errors.length}"
                  )
                  span.help.erro {{ errors[0] }}
              el-col.ml-0.mr-0(:lg="12")
                app-label(label="Valor total:", :required="false")
                el-input.input(disabled v-model="valorTotalFormatado")
            el-row.extra-margin-top(:gutter="40")
              el-col(:span="24")
                app-label(label="Informações adicionais: ", :required="false")
                el-input(
                  type='textarea',
                  :rows='5',
                  placeholder='Digite o texto...',
                  v-model='dae.informacoesAdicionais'
                  name="Informações adicionais",
                  maxlength="500"
                )

  app-buttons-cadastro(
    :isPrimeiroPasso="true",
    :isUltimoPasso="false",
    :showButtonProximo="true"
    :showButtonSalvar="false",
    :isEtapaSalva="false",
    @cancelar="cancelar",
    @proximo="proximo"
  )

</template>
<script>
import { mapActions } from 'vuex'
import AppLabel from '@/components/AppLabel'
import AppDoubleInput from '@/components/AppDoubleInput'
import AppButtonsCadastro from '@/components/AppButtonsCadastro'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import utils from '@/utils/utils'
import CardFinanceiro from '../components/CardFinanceiro'
import AppDivider from '@/components/AppDivider'
import _ from 'lodash'

export default {
  components: {
    AppLabel,
    AppDoubleInput,
    AppButtonsCadastro,
    CardFinanceiro,
    AppDivider
  },
  mixins: [
    AppNotificacao
  ],
  data () {
    return {
      inputDisabled: true,
      upf: null,
      tiposCustas: [],
      dae: {
        tipoCusta: null,
        custas: [],
        tipoReceita: '',
        processoFisico: {
          numero: null,
          tipoCadastro: '',
          nomeRazaoSocialInteressado: '',
          cpfCnpjInteressado: '',
          telefone: '',
          email: '',
          endereco: {
            logradouro: '',
            numero: '',
            complemento: '',
            bairro: '',
            municipio: {
              id: '',
              nome: ''
            }
          }
        },
        dataReferencia: '',
        dataVencimento: '',
        dataCalculo: '',
        valorPrincipal: 0.0,
        valorMulta: 0.0,
        valorCorrecaoMonetaria: 0.0,
        valorAcrescimosMonetarios: 0.0,
        valorTotal: 0.0,
        informacoesAdicionais: ''
      },
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() < Date.now()
        }
      },
      receitas: null
    }
  },

  async created () {
    if (!this.$route.params.numeroProcesso) {
      this.$router.push({ name: 'cof/home' })
      return
    }

    if (this.$route.params.dae) {
      this.dae = this.$route.params.dae
    }

    let processoFisico = await this.findProcessoByNumeroProcesso(this.$route.params.numeroProcesso)
    this.dae.processoFisico = processoFisico
    this.dae.dataCalculo = new Date()
    this.dae.dataReferencia = new Date()

    this.getReceitas().then(tipoReceita => {
      this.receitas = tipoReceita
    })

    this.tiposCustas = await this.getCustas()
    this.upf = await this.getUltimoUpf()
  },

  computed: {
    valorTotal () {
      if (this.dae.custas.length === 0) { return 0.0 }

      const valorTotal = this.dae.custas.reduce((soma, item) => {
        soma += (item.quantidade * item.tipoCusta.indice) * this.upf.valor
        return soma
      }, 0)
      return valorTotal
    },

    valorTotalFormatado () {
      return utils.format(this.valorTotal)
    }
  },

  methods: {
    ...mapActions({
      findProcessoByNumeroProcesso: 'cadastroProcessoFisico/findProcessoByNumeroProcesso',
      getReceitas: 'receitas/getReceitas',
      getCustas: 'cadastroProcessoFisico/getCustas',
      getUltimoUpf: 'vtn/getNewUpf'
    }),

    async proximo () {
      this.$refs.observer.validate().then(async success => {
        if (!success) {
          this.showNotificacao('warning', 'Atenção!', 'Verifique os campos destacados.')
          return false
        } else if (this.dae.custas.length === 0) {
          this.showNotificacao('warning',
            'Atenção!',
            'Adicione ao menos uma custa ' + (this.dae.tipoCusta === 'PROCESSUAIS' ? 'processual' : 'agrária') + ' à composição do DAE')
          document.getElementById('custas').scrollIntoView()
        } else {
          this.$router.push({
            name: 'dae/resumoDae',
            params: {
              dae: {
                ...this.dae,
                valorTotal: this.valorTotal
              }
            }
          })
        }
      })
    },

    cancelar () {
      this.confirmBox(
        'Você tem certeza que deseja voltar? Todos os dados não salvos serão perdidos.',
        this.$messages.TITULO_WARNING,
        () => {
          this.$router.push({
            name: 'cof/visualizarProcessoFisico',
            params: {
              numeroProcesso: this.dae.processoFisico.numero
            }
          })
        },
        () => {},
        'Sim',
        'Não'
      )
    },

    handleChange (quantidade, custa) {
      const custaAux = { quantidade, tipoCusta: { ...custa } }

      const custaState = _.find(this.dae.custas, item => item.tipoCusta.id === custaAux.tipoCusta.id)

      if (!custaState) {
        this.dae.custas.push(custaAux)
      } else {
        custaState.quantidade = custaAux.quantidade

        if (custaState.quantidade === 0) {
          _.remove(this.dae.custas, custaState)
        }
      }
    },

    getCustaValue (id) {
      const custa = _.find(this.dae.custas, item => item.tipoCusta.id === id)

      return custa ? custa.quantidade : 0
    }
  }
}
</script>

<style>
.margin-bottom-20 {
  margin-bottom: 20px;
}

.margin-top-50 {
  margin-top: 50px;
}

span /deep/ .el-input__count-inner {
  color:#009f61
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance:textfield;
}

.full-width {
  width: -webkit-fill-available;
}

.el-date-editor.el-input {
  width: 100%;
}

.el-select {
  width: 100%;
}

.checkbox-group {
  padding: 5px;
}

.custas {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap
}

.input-custas{
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 50%;
  padding: 10px
}

.input-item {
  width: 25%;
}

.span-item {
  width: 80%;
}

@media screen and (max-width: 1200px) {
  .input-custas{
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 10px
  }
}

</style>



// WEBPACK FOOTER //
// src/screens/financeiro/dae/CadastroDae.vue